const ServiceQuestionIndex = () => import('@/pages/lab/servicequestion/ServiceQuestionIndex');
const ServiceQuestionDetail = () => import('@/pages/lab/servicequestion/ServiceQuestionDetail');
const ServiceQuestionEdit = () => import('@/pages/lab/servicequestion/ServiceQuestionEdit');
const ServiceQuestionSingle = () => import("@/pages/lab/servicequestion/ServiceQuestionSingle");

export class ServiceQuestionRoutes {

  constructor() {
    this.route_root = 'laboratory/:laboratory_id/service-questions/';
    this.type_single = 'Service Question';
    this.type_plural = 'Service Questions';

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c('router-view')
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: ServiceQuestionIndex,
            meta: {requiresAuth: true}
          },
          {
            path: ":service_question_id",
            component: ServiceQuestionSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: ServiceQuestionDetail,
                meta: {requiresAuth: true}
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: ServiceQuestionEdit,
                meta: { requiresAuth: true }
              }
            ]
          }
        ]
      }
    ]

    this.public_routes = [];
  }

  static fetchRoutes() {
    const this_obj = new this();

    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    const this_obj = new this();
    
    return this_obj.public_routes;
  }
}

